module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-block",
    class: _vm.data.class
  }, [_vm._v("\n  " + _vm._s(_vm.time) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a0b56fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/BlockDate.vue
// module id = 711
// module chunks = 0